























import Menu from '@/packages/d-menu';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {RouteConfig} from 'vue-router';

Vue.use(Menu);
@Component
export default class NavList extends Vue {
  @Prop({
    type: Array
  })
  public menuList: RouteConfig[]; // 代码片段

  public openKeys: string[] = [];

  public handleClick(route) {
    this.$router.push(route);
  }

}
